// extracted by mini-css-extract-plugin
export var actionButton = "_k4-0";
export var fileInput = "_k4-2";
export var paperclip = "_k4-1";